import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
import setting from '../helpers/setting';

export default class UpvotedNotification extends Notification {
  icon() {
    const icon = setting('iconName') || 'thumbs';

    if (this.attrs.notification.content() > 0) {
      return `fas fa-${icon}-up`;
    } else {
      return `fas fa-${icon}-down`;
    }
  }

  href() {
    return app.route.post(this.attrs.notification.subject());
  }

  content() {
    const user = this.attrs.notification.fromUser();
    const content = parseInt(this.attrs.notification.content());

    if (content > 0) {
      return app.translator.trans('fof-gamification.forum.notification.upvote', { user });
    } else {
      return app.translator.trans('fof-gamification.forum.notification.downvote', { user });
    }
  }

  excerpt() {
    return this.attrs.notification.subject().contentPlain();
  }
}
